import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ServiceForm } from '../../../../../core/Interfaces/ui-interface';
import { PermissionService } from '../../../../../core/services/permission.service';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';  
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { GlobalName } from '../../../../../core/utils/global-name';
import { AppFeatures } from '../../../../../core/utils/app-features';
import { AppActions } from '../../../../../core/utils/app-actions';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { FeatureService } from '../../../../../core/services/feature.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
@Component({
    selector: 'app-permission',
    templateUrl: './permission.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./permission.component.css']
})
export class PermissionComponent implements OnInit {


  @ViewChild('contentAdd') contentAdd:ElementRef | undefined;
  @ViewChild('contentEdit') contentEdit:ElementRef | undefined;
  @ViewChild('contentShow') contentShow:ElementRef | undefined;


  actionTemplate:any
  selected_data:any
  loading:any=false
  feature:any
  search_text=""
  title = 'frontend';
  data:any[]=[]
  features:any[]=[]
  actions:any
  actions2:any[]=["list","add","show","edit","delete","status"]
  actionChosen:any
  tag="admin-permissions"
  pg={
    pageSize:10,
    p:0,
    total:0
  }

  constructor(
    private cdRef:ChangeDetectorRef,
    private featureService:FeatureService,
    private permissionService:PermissionService,
    private toastrService:ToastrService,
    private modalService:NgbModal,
    private localService:LocalStorageService
    ){
    
  }

  ngOnInit(): void {
    this.features=AppFeatures
    //this.actions=AppActions

   this.init()
  }

  getFeatures(){
    this.featureService.getAll2().subscribe((res:any)=>{
      this.features=res.data.features
      this.actions=res.data.actions
     
    },
    (err:any)=>{
    AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
    })
  }

  ngAfterViewInit(): void {
    this.actionTemplate={
      add:{
        type:0,
        path:this.contentAdd
      },
      edit:{
        type:0,
        path:this.contentEdit
      },
      show:{
        type:0,
        path:this.contentShow
      }
    }

    this.cdRef.detectChanges();
  }
  init(){
    this.getAll()
    this.getFeatures()
  }

  getAll(){
    this.permissionService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
    AppErrorShow.showError("Gestion des permissions",err)
    })
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }
  
  
  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.feature=JSON.parse(this.selected_data.menu)
    let myActions=JSON.parse(this.selected_data.actions)
    this.actionChosen=this.actions
    for (const key in myActions) {
      if (Object.prototype.hasOwnProperty.call(myActions, key)) {
        this.actionChosen[key]=true;
      }
    }
    console.log(this.actionChosen)
    this.modalService.open(content,{size:'lg'});
  }

  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }

  checked(el:any){
    this.selected_data=el;
    this.feature=JSON.parse(this.selected_data?.menu)
    console.log(this.feature)
  }

  create(value:any){

    this.loading=true
  
    this.permissionService.store(value).subscribe((res:any)=>{
      this.toastrService.success(res.message)
      this.getAll()
      this.loading=false

  },
  (err:any)=>{
    this.loading=false
    AppErrorShow.showError("Gestion des permissions",err)

   
  })
  }

  getPage(event:any){
    this.pg.p=event
  }


  update(value:any){
    this.loading=true

    this.permissionService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.toastrService.success(res.message)
      this.getAll()
      this.loading=false

  },
  (err:any)=>{
    this.loading=false
    AppErrorShow.showError("Gestion des permissions",err)

  })
  }

  delete(){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.permissionService.delete(this.selected_data.id).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        AppErrorShow.showError("Gestion des permissions",err)

      })
              }
            })

}

getJson(arr:any){
  return JSON.parse(arr)
}

}
